import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import Text from '../Text';

const StyledLink = styled(NavLink)`
  text-decoration: none;
  display: block;
  color: ${({ color }) => color};

  &:hover {
    color: ${theme.colors.primary};
  }
`;

const Anchor = ({
  children,
  to,
  color,
  onClick,
  size,
  strong,
  underline,
  ...props
}) => {
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <StyledLink
      to={to}
      onClick={handleClick}
      color={color}
      style={props.style}
      activeStyle={{
        color: theme.colors.primary,
        fontWeight: 600,
      }}
      exact
    >
      <Text size={size} color="inherit" strong={strong} underline={underline}>
        {children}
      </Text>
    </StyledLink>
  );
};

Anchor.propTypes = {
  children: PropTypes.string.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'md', 'lg']),
  color: PropTypes.string,
  strong: PropTypes.bool,
  underline: PropTypes.bool,
  style: PropTypes.object,
};

Anchor.defaultProps = {
  onClick: () => {},
  size: 'base',
  color: theme.colors.fontBase,
  strong: false,
  underline: false,
  style: {},
};

export default Anchor;
